import { render, staticRenderFns } from "./EmployeeAddressField.vue?vue&type=template&id=353ba0b0&"
import script from "./EmployeeAddressField.vue?vue&type=script&lang=js&"
export * from "./EmployeeAddressField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('353ba0b0')) {
      api.createRecord('353ba0b0', component.options)
    } else {
      api.reload('353ba0b0', component.options)
    }
    module.hot.accept("./EmployeeAddressField.vue?vue&type=template&id=353ba0b0&", function () {
      api.rerender('353ba0b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/profile/fields/EmployeeAddressField.vue"
export default component.exports